import axios from 'axios';
import {apiConfig} from '../config';
const apiClient = axios.create({
  baseURL: apiConfig.host
});
const sessionActions = {
  verifyToken: ({idToken}:{idToken: string}) => {
    return apiClient.post('/firebase/verify', { idToken });
  }
}

export default sessionActions;